// Model.js
// -----------------------
// @module Case
define("BluePoint.ValidateRegistration.ValidateRegistration.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/ValidateRegistration/SuiteScript2/ValidateRegistration.Service.ss"
            ),
            true
        )
    });
});
